export default "__VITE_ASSET__DkZO8E0i__"